import React, { useState, useEffect } from "react";
import TopHeading from "../Heading/TopHeading";
import { Row, Col, Form, Table } from "react-bootstrap";
import Select from "react-select";
import BookingItem from "./BookingItem";
import { Loader, NoContent, Pagination, SearchBar } from "../UI";
import axios from "../../axios";
import { toast } from "react-toastify";

export default function BookingsContent() {
  const authToken = localStorage.getItem("access_token");
  const isAdmin = localStorage.getItem("isAdmin");
  const apiURL = isAdmin == 0 ? "/user-bookings" : "bookings";
  const [bookings, setBookings] = useState([]);
  const [currentBookings, setCurrentBookings] = useState([]);
  const itemsPerPage = 12;
  const [isLoading, setIsLoading] = useState(true);
  const selectStyles = { borderColor: "#0755991e" };
  const statusOpts = [
    { value: "paid", label: "Paid" },
    { value: "unpaid", label: "Unpaid" },
  ];
  const [serviceSearch, setServiceSearch] = useState("");
  const [parentSearch, setParentSearch] = useState("");
  const [selectedStatus, setSelectedStatus] = useState(null);

  const filterMethods = [
    (item) =>
      (item.booking_parent.firstName + " " + item.booking_parent.lastName)
        .toLowerCase()
        .indexOf(parentSearch.toLowerCase()) != -1,
    (item) =>
      item.booking_service.title
        .toLowerCase()
        .indexOf(serviceSearch.toLowerCase()) != -1,
    (item) =>
      selectedStatus !== null ? item.status === selectedStatus.value : true,
  ];

  const filteredBookings = bookings.filter((item) => {
    for (let i = 0; i < filterMethods.length; i++) {
      if (!filterMethods[i](item)) {
        return false;
      }
    }
    return true;
  });

  const handleStatus = (id, status) => {
    axios
      .put(
        "/bookings/" + id,
        { status },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      )
      .then((response) => {
        if (response.data) {
          if (response.status === 200) {
            toast.success(response.data.message);
            fetchBookings();
          } else {
            toast.warn("No response from server");
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        toast.error("Something went wrong");
        console.log(error);
        setIsLoading(false);
      });
  };

  const fetchBookings = () => {
    axios
      .get(apiURL, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      })
      .then((response) => {
        if (response.data) {
          if (response.status === 200) {
            setBookings(response.data);
          } else {
            toast.warn("No response from server");
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        toast.error("Couldn't load bookings");
        setIsLoading(false);
      });
  };

  useEffect(() => {
    fetchBookings();
  }, []);

  return (
    <section className="bookings-content">
      <div className="container">
        <div className="row g-0">
          <div className="col-md-12">
            <TopHeading title="Bookings" />
            <div className="bookings light-bg corner-radius p-4 mb-3 main-content custom-scrollbar">
              <div className="">
                <Form>
                  <Row>
                    <Col md="4">
                      <Form.Group className="mb-3">
                        <Form.Label>Status</Form.Label>
                        <Select
                          styles={{
                            control: (styles) => ({
                              ...styles,
                              ...selectStyles,
                            }),
                          }}
                          options={statusOpts}
                          isSearchable={false}
                          isClearable={true}
                          onChange={(option) => setSelectedStatus(option)}
                        />
                      </Form.Group>
                    </Col>
                    {isAdmin != 0 && (
                      <Col md="4">
                        <Form.Group className="mb-3">
                          <Form.Label>Parent Name</Form.Label>
                          <SearchBar
                            placeholder="Search Parent Name"
                            value={parentSearch}
                            onChange={(e) => setParentSearch(e.target.value)}
                          />
                        </Form.Group>
                      </Col>
                    )}
                    <Col md="4">
                      <Form.Group className="mb-3">
                        <Form.Label>Activity Name</Form.Label>
                        <SearchBar
                          placeholder="Search Activity Name"
                          value={serviceSearch}
                          onChange={(e) => setServiceSearch(e.target.value)}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </Form>
              </div>
              <Table className="list-table align-middle" borderless responsive>
                <thead className="primary-button fw-bold">
                  <tr>
                    <td>Activity</td>
                    <td>Parent</td>
                    <td>Dated on</td>
                    <td>Status</td>
                    <td>Actions</td>
                  </tr>
                </thead>
                <tbody>
                  {!isLoading ? (
                    filteredBookings.length ? (
                      filteredBookings.length > itemsPerPage ? (
                        currentBookings.map((item) => {
                          return (
                            <BookingItem
                              key={item.bookingId}
                              data={item}
                              handleStatus={handleStatus}
                              setIsLoading={setIsLoading}
                            />
                          );
                        })
                      ) : (
                        filteredBookings.map((item) => {
                          return (
                            <BookingItem
                              key={item.bookingId}
                              data={item}
                              handleStatus={handleStatus}
                              setIsLoading={setIsLoading}
                            />
                          );
                        })
                      )
                    ) : (
                      <tr>
                        <td colSpan={5}>
                          <NoContent />
                        </td>
                      </tr>
                    )
                  ) : (
                    <tr>
                      <td colSpan={5}>
                        <Loader />
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
              {filteredBookings.length > itemsPerPage && (
                <div className="d-flex justify-content-end">
                  <Pagination
                    data={filteredBookings}
                    setCurrentItems={setCurrentBookings}
                    itemsPerPage={itemsPerPage}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
